// extracted by mini-css-extract-plugin
export default {"deleteBtn":"deleteConfirmation__deleteBtn--NFqO4"};